<script setup lang="ts">
import { ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { useUserStore } from '@/stores/user'
import { useOnlineStore } from '@/stores/online'
import { useRegisteredStore } from '@/stores/registered'
import { storeToRefs } from 'pinia'

const dropdownRef = ref<HTMLUListElement | null>(null)
const isDropdownOpen = ref(false)
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const onlineStore = useOnlineStore()
const { online } = storeToRefs(onlineStore)
const registeredStore = useRegisteredStore()
const { registered } = storeToRefs(registeredStore)

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value
}

const closeDropdown = () => {
  isDropdownOpen.value = false
}

onClickOutside(dropdownRef, closeDropdown)
</script>

<template>
  <nav class="navbar navbar-default navbar-static-top">
    <a class="navbar-brand" href="#">
      <img style="margin: auto; user-select: none" src="../assets/callingly-small-white2.png" />
    </a>

    <ul v-if="user?.id" class="nav navbar-right">
      <li class="dropdown" :class="{ open: isDropdownOpen }" ref="dropdownRef">
        <a
          style="
            user-select: none;
            height: 69px;
            display: flex;
            align-items: center;
            background-color: transparent !important;
          "
          href="#"
          class="dropdown-toggle"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          @click.stop="toggleDropdown"
        >
          <img
            id="profile"
            class="img-responsive pull-left"
            :class="{ online: online && registered, offline: !online || !registered }"
            style="height: 36px; width: 36px; border-radius: 50%; margin-right: 10px"
            :src="user?.profile_picture"
          />
          <span style="color: #a7b1c2"
            ><span style="max-width: 150px; overflow: hidden; float: left; white-space: nowrap">{{
              user?.full_name
            }}</span>
            <i
              style="
                font-size: 18px;
                margin-left: 5px;
                margin-right: 10px;
                float: right;
                margin-top: 1px;
              "
              class="material-icons"
              >keyboard_arrow_down</i
            ></span
          >
        </a>

        <ul
          class="dropdown-menu add-triangle dropdown-menu-right"
          style="user-select: none; margin-right: 20px; min-width: 300px"
          @click.stop
        >
          <li style="padding: 10px 20px" class="clearfix">
            <img
              class="img-responsive pull-left"
              style="max-height: 80px; border-radius: 50%; margin-right: 15px"
              :src="user?.profile_picture"
            />
            <div style="font-size: 20px; margin-top: 0px; color: #073b4c; font-weight: bold">
              {{ user?.full_name }}
            </div>
            <div style="float: left; font-size: 13px; color: #a7b1c2; margin-top: 5px">
              {{ user?.email }}
            </div>
            <div style="float: left; font-size: 13px; color: #a7b1c2; margin-top: 5px">
              {{ user?.phone_number_formatted }}
            </div>
          </li>

          <li role="separator" class="divider" />
          <li style="padding: 10px 20px; display: flex; align-items: center; justify-content: space-between">
            <span style="color: #333">Do Not Disturb</span>
            <label class="dnd-toggle">
              <input type="checkbox" :checked="user?.donotdisturb" @change="userStore.toggleDnd" />
              <span class="dnd-slider"></span>
            </label>
          </li>
          <li role="separator" class="divider" />
          <li style="padding-bottom: 5px">
            <a href="#" @click="userStore.logout">Log out</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>
<style scoped>
.navbar {
  min-height: 70px;
  margin-bottom: 0;
}

.navbar-brand {
  float: left;
  cursor: default;
}

.navbar-default {
  border-color: transparent;
  background: #073b4c;
}

.navbar-right {
  float: right;
}

.navbar-default .navbar-nav > li > a {
  text-transform: uppercase;
  letter-spacing: 1.4px;
}

nav.navbar-fixed-bottom li.active a {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.dropdown-menu > .active > a,
.dropdown-menu > .active:hover > a {
  color: #333;
  background-color: #ebebeb;
}

.dropdown-menu-right {
  right: -10px;
}

#profile.online {
  border: 2px solid #00b300;
}

#profile.offline {
  border: 2px solid #dc143c;
}

.dnd-toggle {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  margin: 0;
}

.dnd-toggle input {
  opacity: 0;
  width: 0;
  height: 0;
}

.dnd-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.3s;
  border-radius: 24px;
}

.dnd-slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
}

.dnd-toggle input:checked + .dnd-slider {
  background-color: #dc143c;
}

.dnd-toggle input:checked + .dnd-slider:before {
  transform: translateX(20px);
}
</style>
